/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useEntityThumbnailStyles = makeStyles(theme =>
  createStyles({
    image: {
      width: '100%',
      height: '100%',
      '&$editable': {
        cursor: 'pointer',
      },
    },
    fileInput: {
      opacity: 0,
      position: 'absolute',
      zIndex: -1,
    },
    root: {
      overflow: 'hidden',
      borderRadius: '6px',
      display: 'block',
      width: '100%',
      height: '100%',

      '&$editable': {
        transition: 'box-shadow .2s ease',
        '&:hover': {
          boxShadow: `0px 0px 10px ${theme.palette.tertiary.main}`,
        },
      },
    },
    editable: {},
  }),
);
